
// const HOST = '/api' //本地测试

const HOST = process.env.VUE_APP_BASE_URL

export default HOST